import { StyledButton } from './Button.styles.js';

const Button = (props) => {
    return <StyledButton {...props} />;
};

export default Button;
